import React, { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import PublicIcon from '@mui/icons-material/Public'; // Для VK
import axios from '../api/axios';

const Footer = () => {
  const [settings, setSettings] = useState({
    phone: '+7 (XXX) XXX-XX-XX',
    email: 'info@example.com',
    address: 'Адрес',
    workSchedule: 'Понедельник - Пятница: 9:00 - 18:00',
    facebook: '',
    instagram: '',
    telegram: '',
    vk: '',
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get('/settings/public');
      setSettings(response.data);
    } catch (error) {
      console.error('Ошибка загрузки настроек:', error);
    }
  };
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'white',
        pt: 6,
        pb: 4,
        mt: 8,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom fontWeight={700} sx={{ lineHeight: 1.3, maxWidth: '100%', overflow: 'hidden', fontSize: { xs: '0.9rem', sm: '1.25rem' } }}>
              <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                Консультационный{'\u00A0'}центр
              </Box>
              <Box component="span" sx={{ display: 'block', whiteSpace: { xs: 'normal', sm: 'nowrap' }, maxWidth: '100%' }}>
                "Волшебная{'\u00A0'}страна"
              </Box>
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9, fontSize: { xs: '0.75rem', sm: '0.875rem' } }}>
              МАДОУ МО г.{'\u00A0'}Краснодар "Детский{'\u00A0'}сад{'\u00A0'}№{'\u00A0'}213"
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              Бесплатная консультационная помощь семьям в рамках национального проекта «Образование»
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {settings.facebook && (
                <IconButton 
                  color="inherit" 
                  size="small" 
                  href={settings.facebook} 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <FacebookIcon />
                </IconButton>
              )}
              {settings.instagram && (
                <IconButton 
                  color="inherit" 
                  size="small" 
                  href={settings.instagram} 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <InstagramIcon />
                </IconButton>
              )}
              {settings.telegram && (
                <IconButton 
                  color="inherit" 
                  size="small" 
                  href={settings.telegram} 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Telegram"
                >
                  <TelegramIcon />
                </IconButton>
              )}
              {settings.vk && (
                <IconButton 
                  color="inherit" 
                  size="small" 
                  href={settings.vk} 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="VK"
                >
                  <PublicIcon />
                </IconButton>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom fontWeight={700}>
              Контакты
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon fontSize="small" />
                <Typography variant="body2">{settings.phone}</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Typography variant="body2">{settings.email}</Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationOnIcon fontSize="small" />
                <Typography variant="body2">
                  {settings.address}
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>

          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            mt: 4,
            pt: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" sx={{ opacity: 0.8, lineHeight: 1.5 }}>
            © {new Date().getFullYear()} Консультационный{'\u00A0'}центр<br />
            "Волшебная{'\u00A0'}страна". Все права защищены.
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.7, display: 'block', mt: 1 }}>
            Национальный проект «Образование»
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
